<template>
  <DropdownMenu ref="menu" :auto-close="false">
    <template v-slot:activator>
      <Button round flat icon="more_vert" color="standard" />
    </template>

    <template v-slot:content>
      <List>
        <Item
          tag="label"
          clickable
          v-ripple
          v-for="item in options"
          @click="item.checkable ? undefined : onClickMenu(item.action)"
          :key="item.action"
        >
          <ItemSection side top v-if="item.checkable">
            <Checkbox v-model="item.isChecked" />
          </ItemSection>

          <ItemSection avatar v-else-if="item.icon">
            <Avatar :icon="item.icon" />
          </ItemSection>

          <ItemSection>
            <ItemLabel>{{ item.label }}</ItemLabel>
            <ItemLabel caption>
              {{ item.description }}
            </ItemLabel>
          </ItemSection>
        </Item>
      </List>
    </template>
  </DropdownMenu>
</template>

<script>
import Avatar from '../Avatar';
import DropdownMenu from '../DropdownMenu';
import Button from '../Button';
import List from '../List';
import Item from '../Item';
import ItemSection from '../ItemSection';
import ItemLabel from '../ItemLabel';
import Checkbox from '../Checkbox';

export default {
  name: 'GlobalActionMenu',
  components: { DropdownMenu, Button, List, Item, ItemSection, ItemLabel, Avatar, Checkbox },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClickMenu(action) {
      if (action === 'changeColumn') {
        this.$refs['menu'].hide();
      }

      this.$emit('click', action);
    },
  },
};
</script>

<style lang="scss" scoped></style>
